import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LoaderService, MessageService } from '@shared';
import { Tier, TiersService } from '@shared-data';

@Component({
  selector: 'app-remove-tier',
  templateUrl: './remove-tier.component.html',
  styleUrl: './remove-tier.component.scss',
})
export class RemoveTierComponent {
  @Input()
  tierToRemove!: Tier;

  @Output()
  onConfirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private tierService: TiersService,
    private messageService: MessageService,
    private loaderService: LoaderService,
  ) {}
  onCancel() {
    this.onConfirm.emit(false);
  }

  onProceed() {
    this.loaderService.show();
    if (this.tierToRemove === null) return;
    this.tierService.removeTier(this.tierToRemove?.id, null).subscribe({
      next: () => {
        this.onConfirm.emit(true);
        this.loaderService.hide();
      },
      error: (err) => {
        this.messageService.error(`Failed to remove tier: ${err.error}`);
        this.loaderService.hide();
        this.onConfirm.emit(false);
      },
    });
  }
}
